export default "__VITE_ASSET__23d972c5__"